import { AppModule } from '@/store/modules/app'
import { Component, Vue } from 'vue-property-decorator'
import { getCurrency } from '@/utils/cookies'

@Component({
  name: 'currencyOptionMixin'
})
export default class extends Vue {
  protected queryForm: any = {
    currency: getCurrency() || AppModule.currentCurrencyType || 'THB',
  }
  protected currencyTypes: any[] = AppModule.enterprise.available_currency

  protected setCurrency(fn: any, params: any) {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    fn(params)
  }
}